<script>
	import { TodaysData, IsNative, Promises, Version } from '$lib/store.js';
	import { delay } from '$lib/utils.js';
	import { onMount } from 'svelte';
	import Modal from '../Modal.svelte';
	import Favicon from '../Favicon.svelte';
	import { makeDecimalIntoTime } from '$lib/connectUtils.js';
	import QuickRecategorize from '../QuickRecategorize.svelte';
	export let divName,
		seeAll = false,
		total_time,
		activities,
		recategoriseToShow = {},
		categories,
		activityDetails;
	$: firefox = activities?.filter((event) => event[1]?.app.includes('Firefox'));
	$: firefoxUntracked =
		($Version.platform == 'macos' || $Version.platform == 'darwin') &&
		firefox.length &&
		firefox?.every((event) => !event[1]?.url);
	$: if (firefoxUntracked) {
		console.log('firefoxUntracked', firefoxUntracked, firefox);
	}
	let showFirefox = false;
	onMount(async () => {
		showFirefox = localStorage.showFirefox != 'false';
		// await delay(1000);
	});
</script>

{#if firefoxUntracked && showFirefox}
	<Modal on:close={() => (localStorage.showFirefox = false)} bind:show={showFirefox}>
		<div class="flex flex-col gap-2 items-center text-lg font-medium p-8">
			<div class="flex justify-center">
				<img
					class="w-32 rounded-lg"
					src="data:image/jpeg;base64,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"
					alt="firefox logo"
				/>
			</div>
			<div class="mb-4">
				Magicflow can't track URLs in Firefox without you making a small change to your Firefox
				settings. In Firefox:
			</div>
			<div class="max-w-2xl mx-auto p-4 px-6 bg-gray-800 rounded-xl my-4">
				<ol class="list-decimal ml-4">
					<li>Go to about:config using your address bar and accept the warning</li>
					<li>Set the property: accessibility.force_disabled to -1</li>
				</ol>
			</div>
			<div>
				This enables some accessibility settings in Firefox which Magicflow will use to start
				picking up URLs!
			</div>
		</div>
	</Modal>
{/if}
<div
	class="{seeAll
		? `relative bottom-0 max-h-28 overflow-y-auto ${$IsNative ? '' : ' sm:w-[560px]'}`
		: 'relative  w-full'} grid mt-1 max-w-md text-xs gap-x-4 text-left"
	style="grid-template-columns: 1fr 1fr !important;max-height:90vh;{divName.includes('Preview')
		? ''
		: seeAll
		  ? 'min-height:12rem;max-height: 100vh;'
		  : 'min-height:6.5rem'}"
>
	<!-- {#key events} -->
	<!-- {#if !i}
						<button
							class="absolute hidden z-10 shadow-none bottom-full left-1/2 -translate-x-1/2"
							on:click={() => (recategorize = true)}
						>
							Recategorize
						</button>
					{/if} -->

	{#each [['working', activities?.filter((event) => event[1]?.work)], ['not working', activities?.filter((event) => !event[1]?.work)]] as [name, events], isNotWork (name)}
		<div>
			{#if !divName.includes('Preview')}
				<div class="flex justify-between">
					<div class="capitalize font-semibold">{name}</div>
					<div style="color:{isNotWork ? '#ee4656' : '#00ee33'};" class="font-semibold text-xs">
						{#each (total_time || $TodaysData?.total_time) && (total_time || $TodaysData?.total_time)[isNotWork ? 'unproductive' : 'productive'] !== undefined ? makeDecimalIntoTime((total_time || ($TodaysData?.total_time && $TodaysData?.total_time))[isNotWork ? 'unproductive' : 'productive'] / 3600) : ['--', '--'] as time, i}
							{time || 0}<span>{i ? '' : 'h '}</span>
						{/each}
					</div>
				</div>
			{/if}
			<div>
				{#each events.slice(0, seeAll || divName.includes('TimeWorkingDetails') ? events?.length : divName.includes('Preview') ? 3 : divName?.includes('week') ? 7 : 5) as [type, data], i (data.timestamp)}
					{#if !(type && data)}
						<div class="h-4" />
					{:else}
						<div
							on:click|stopPropagation={() => {
								activityDetails = { type, data, work: data.work };
								console.log({ activityDetails, data, type });
							}}
							on:mouseover={delay(
								() => {
									// console.log('mouseenter');
									if (
										recategoriseToShow?.activities ===
										JSON.stringify(data?.app + data?.title + data?.url + data?.categories?.[0] + i)
									)
										data.hovering = true;
									recategoriseToShow.activities = JSON.stringify(
										data?.app + data?.title + data?.url + data?.categories?.[0] + i
									);
								},
								recategoriseToShow.activities ? 0 : 173
							)}
							on:mouseleave={() => {
								console.log('mouseleave');
								data.hovering = false;
								setTimeout(() => {
									if (
										!data.hovering &&
										recategoriseToShow?.activities ==
											JSON.stringify(
												data?.app + data?.title + data?.url + data?.categories?.[0] + i
											)
									)
										recategoriseToShow.activities = false;
								}, 250);
							}}
							on:focus={delay(
								() => {
									console.log('focus');
									if (
										recategoriseToShow?.activities ===
										JSON.stringify(data?.app + data?.title + data?.url + data?.categories?.[0] + i)
									)
										data.hovering = true;
									recategoriseToShow.activities = JSON.stringify(
										data?.app + data?.title + data?.url + data?.categories?.[0] + i
									);
								},
								recategoriseToShow.activities ? 0 : 173
							)}
							on:blur={() => {
								console.log('blur');
								data.hovering = false;
								setTimeout(() => {
									if (
										!data.hovering &&
										recategoriseToShow?.activities ==
											JSON.stringify(
												data?.app + data?.title + data?.url + data?.categories?.[0] + i
											)
									)
										recategoriseToShow.activities = false;
								}, 250);
							}}
							class="flex relative justify-between items-center font-medium cursor-pointer"
							style="line-height:1.15;color:{data?.work
								? `${data?.focus ? '#00ee33' : '#ccdd55'}`
								: '#ee4656'};"
						>
							<div class="reinvert">
								<Favicon {type} {data} />
							</div>
							<div
								style="white-space: nowrap;margin-right:auto;"
								class={type && type?.split(': ')[0] === 'Site' ? '' : 'capitalize'}
							>
								{type && (type?.split(': ')[1] || console.log({ type, data }) || '').slice(0, 15)}
							</div>
							<div style="white-space: nowrap;">
								{(data &&
									data?.duration &&
									makeDecimalIntoTime(
										data?.duration < 0 ? 0 : data?.duration / 3600,
										'durationNoZeroWithSeconds'
									)) ||
									'0s' ||
									''}
							</div>

							{#if !$IsNative && recategoriseToShow?.activities == JSON.stringify(data?.app + data?.title + data?.url + data?.categories?.[0] + i)}
								<QuickRecategorize
									{divName}
									{i}
									parentShow={'activities'}
									bind:recategoriseToShow
									position={'left-1/2 -bottom-2'}
									{categories}
									{data}
									{type}
								/>
							{/if}
						</div>
					{/if}
				{/each}
			</div>
			<!-- what app/url, category -->
		</div>
	{/each}
	{#if !divName.includes('Preview') && !divName.includes('TimeWorkingDetails')}
		<button
			on:click={() => (seeAll = !seeAll)}
			class="h-max mt-auto {seeAll
				? ''
				: 'seeAll opacity-0'} transition-opacity py-0 pb-0.5 px-2 mx-auto font-semibold col-span-2 bg-gray-200 text-black cursor-pointer text-center text-xs"
		>
			{!seeAll ? 'See all' : 'See less'}
		</button>
	{/if}
	<!-- {/key} -->
</div>

<style>
	div:hover > .seeAll {
		opacity: 1;
	}
</style>
